export const preMadeIngredientForForms = [
    'Appetizer', 'Breakfast', 'Brunch', 'Lunch', 'Dinner', 'Snack', 'Dessert', 'Salad', 'Soup', 'Side Dish', 'Main Course', 'Beverage', 'Sauce', 'Marinade', 'Dip', 'Bread', 'Condiment', 'Casserole', 'Smoothie', 'Cocktail', 'Mocktail'
];

export const preMadeIngredientTags = [
    'BBQ',
    'Grill',
    'Pasta',
    'Pizza',
    'Seafood',
    'Vegetarian',
    'Vegan',
    'Gluten-Free',
    'Keto',
    'Paleo',
    'Low-Carb',
    'Low-Fat',
    'Low-Sodium',
    'High-Protein',
    'Holiday',
    'Seasonal',
    'Comfort Food',
    'Quick & Easy',
    'Slow Cooker',
    'Instant Pot',
    'Air Fryer',
    'Baking',
    'Grilling',
    'Roasting',
    'Steaming',
    'Stir-Fry',
    'One-Pot',
    'Sheet Pan',
    'Meal Prep',
    'Kid-Friendly',
    'Budget-Friendly',
    'Healthy',
    'Indulgent',
    'Ethnic',
    'Fusion',
    'Traditional',
    'Gourmet',
    'Simple',
    'Elegant',
    'Party',
    'Picnic',
    'Camping',
    'Tailgating',
    'Potluck',
    'Family',
    'Romantic',
    'Comfort',
    'Festive',
    'Celebration',
    'Weeknight',
    'Weekend',
    'Special Occasion',
    'Everyday',
    'Spring',
    'Summer',
    'Fall',
    'Winter',
    'Christmas',
    'Thanksgiving',
    'Easter',
    'Halloween',
    `Valentine’s Day`,
    'Fourth of July',
    "New Year’s",
    `St. Patrick’s Day`,
    'Cinco de Mayo',
    'Hanukkah',
    'Passover',
    'Diwali',
    'Ramadan',
    'Chinese New Year',
    'Oktoberfest',
    'Mardi Gras',
    'Super Bowl',
    'Birthday',
    'Anniversary',
    'Graduation',
    'Baby Shower',
    'Bridal Shower',
    'Wedding',
    'Engagement',
    'Retirement',
    'Housewarming',
    'Farewell',
    'Welcome Home',
    'Get Well',
    'Sympathy',
    'Thank You',
    'Congratulations',
    'Good Luck',
    'Bon Voyage',
    'Just Because',
    'Thinking of You',
    'Apology',
    'Friendship',
    'Support',
    'Encouragement',
    'Motivation',
    'Inspiration',
    'Peace',
    'Harmony',
    'Balance',
    'Wellness',
    'Mindfulness',
    'Self-Care',
    'Relaxation',
    'Rejuvenation',
    'Renewal',
    'Transformation',
    'Growth',
    'Change',
    'Adventure',
    'Exploration',
    'Discovery',
    'Creativity',
    'Innovation',
    'Imagination',
    'Expression',
    'Art',
    'Music',
    'Dance',
    'Theater',
    'Film',
    'Literature',
    'Poetry',
    'Storytelling',
    'Photography',
    'Crafts',
    'DIY',
    'Gardening',
    'Cooking',
    'Travel',
    'Nature',
    'Outdoors',
    'Sports',
    'Fitness',
    'Exercise',
    'Yoga',
    'Meditation',
    'Nutrition',
    'Diet',
    'Lifestyle',
    'Sustainability',
    'Environment',
    'Community',
    'Service',
    'Volunteering',
    'Charity',
    'Philanthropy',
    'Activism',
    'Advocacy',
    'Education',
    'Learning',
    'Teaching',
    'Mentoring',
    'Coaching',
    'Training',
    'Development',
    'Success',
    'Achievement',
    'Goals',
    'Dreams',
    'Aspirations',
    'Vision',
    'Mission',
    'Purpose',
    'Values',
    'Principles',
    'Integrity',
    'Honesty',
    'Trust',
    'Respect',
    'Kindness',
    'Compassion',
    'Empathy',
    'Understanding',
    'Patience',
    'Tolerance',
    'Acceptance',
    'Forgiveness',
    'Gratitude',
    'Appreciation',
    'Love',
    'Joy',
    'Happiness',
]